import { colors, cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

import { BREAKPOINT_MOBILE } from '../breakpoints';

type Props = {
  children?: React.ReactNode;
  className?: string;
  legendText: string;
  required?: boolean;
};

const Root = styled.fieldset`
  border: 0;
  display: flex;
  flex: 1;
  padding: 0;

  @media (max-width: ${BREAKPOINT_MOBILE}px) {
    flex-direction: column;

    & > * + * {
      margin-block-start: 8px;
    }
  }
`;

const LeftCol = styled.div`
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
  box-sizing: border-box;
  max-width: 200px;
  padding-inline-end: 24px;

  @media (max-width: ${BREAKPOINT_MOBILE}px) {
    max-width: none;
  }
`;

const RightCol = styled.div`
  flex: 1;
`;

const StyledLegend = styled.legend`
  color: ${cssThemedValue('textSecondary')};
`;

const Asterisk = styled.span`
  color: ${colors.strawberry100};
`;

// Custom implementation (instead of using FormRow) in order to support better accessibility (i.e. for screen readers)
// Further info from slack discussion: https://wolt.slack.com/archives/C02ADRD6XMM/p1647427737984719
const MultiInputFormRow = ({ children, className, legendText, required }: Props) => (
  <Root className={className}>
    <LeftCol>
      <StyledLegend>
        <T.Body3>
          {legendText}
          {required && <Asterisk>{' *'}</Asterisk>}
        </T.Body3>
      </StyledLegend>
    </LeftCol>

    <RightCol>{children}</RightCol>
  </Root>
);

export default MultiInputFormRow;
